export const STEPS = ['location', 'service', 'enter-phone', 'show-created-booking']
